import { Github, GitMerge, GitPullRequest } from "lucide-react";
import { Button } from "../../../ui/button";

interface NoAccountsEmptyStateProps {
  onManual: () => void;
}

export function NoAccountsEmptyState({ onManual }: NoAccountsEmptyStateProps) {
  const providers = [
    { label: "GitHub", icon: Github },
    { label: "GitLab", icon: GitMerge },
    { label: "Bitbucket", icon: GitPullRequest },
  ];

  return (
    <div className="bg-card rounded-lg p-4 flex flex-col items-center gap-3 text-center">
      <div className="h-9 w-9 rounded-full bg-muted flex items-center justify-center">
        <GitMerge className="h-4 w-4 text-muted-foreground" />
      </div>
      <div>
        <p className="text-sm font-medium">Connect a Git account</p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Browse and deploy from your private repositories
        </p>
      </div>
      <div className="flex gap-2">
        {providers.map(({ label, icon: Icon }) => (
          <Button
            key={label}
            variant="outline"
            size="sm"
            className="gap-1.5 text-xs h-8"
            asChild
          >
            <a href="/integrations" target="_blank" rel="noopener noreferrer">
              <Icon className="h-3.5 w-3.5" />
              {label}
            </a>
          </Button>
        ))}
      </div>
      <button
        type="button"
        onClick={onManual}
        className="text-xs text-muted-foreground hover:text-foreground underline-offset-2 hover:underline"
      >
        Enter URL manually instead →
      </button>
    </div>
  );
}
